import { Component, OnInit, EventEmitter, Input, Output, OnDestroy, NgModule, forwardRef } from '@angular/core';
import { DatePipe, LowerCasePipe, CommonModule, NgTemplateOutlet } from '@angular/common';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { UserService } from 'app/Shared/Services/user.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { HttpErrorResponse } from '@angular/common/http';
import {default as AggoOrderColumnsJSON} from 'app/Shared/Constant/Grid Column Names/AGGO-Columns.json';
import {default as TDETColumnsJSON} from 'app/Shared/Constant/Grid Column Names/TDET-Columns.json';
import {default as LegDetailsColumnsJSON} from 'app/Shared/Constant/Grid Column Names/LegDetails-Columns.json';
import { MessageService,ConfirmationService } from 'primeng/api';
import { Util } from 'app/Shared/Constant/Util';
import { GridService } from 'app/Shared/Services/grid.service';
import { FinraExceptionService } from 'app/Pages/cat-dashboard/finra-exception/finra-exception.service';
import { DataService } from 'app/Shared/Services/data.service';
import { EventConversionService } from '../event-conversion/event-conversion.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { FieldDictionary } from 'app/Pages/cat-dashboard/finra-exception/field-dictionary.model';
import { map } from 'rxjs';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { DrawerModule } from 'primeng/drawer';
import { MatDividerModule } from '@angular/material/divider';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToastModule } from 'primeng/toast';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
    selector: 'app-single-edit-form',
    imports: [CommonModule, ButtonModule, MatTooltipModule, TableModule, MatExpansionModule,
        MatChipsModule, MatProgressSpinnerModule, MatChipsModule,
        MatExpansionModule, LowerCasePipe,
        ConfirmDialogModule, Select, FormsModule,
        DrawerModule, MatDividerModule, DialogModule, MultiSelectModule, DatePickerModule, NgTemplateOutlet,
        ToggleSwitchModule, ToastModule
    ],
    templateUrl: './single-edit-form.component.html',
    styleUrls: ['./single-edit-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => SingleEditFormComponent),
        }
    ]
})
export class SingleEditFormComponent implements OnInit, OnDestroy {
  @Input() rowData: any;
  @Input() value!: string;
  @Input() index: number | any;
  @Input() screenType!: string;
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() isMultiEdit!: boolean;
  @Input() firmROEIDList!: Array<string>;
  @Input() correctCodeLength!: number;
  @Input() pageName!: string;

  Edit: boolean = false;
  View: boolean = false;
  displayDialog: boolean = false;
  selectedRow: any = [];
  Editviewcols: any = [];
  BooleanDropDown: any = [{
    label: "true", value: true, description: "True"
  },
  {
    label: "false", value: false, description: "False"
  }];
  newLabel!: string;
  aggoOrdersCols: any;
  aggoOrdersData: any;
  handlingInstructionCols: any;
  handlingInstructionData: any;
  tradeSideDetailsCols: any;
  legDetailsCols:any;
  tradeSideDetailsData: any;
  isClickedOnce: boolean = false;
  selectedRowOriginalJSON: any[] = [];
  selectedRowJSONDataset: any[] = [];
  quickviewcols: any = [];
  EventType!: string;
  tempDataset: any = [];
  TimeDropDown: any;
  handlingInstructionObj:any = {};
  timeInForceObj = {};
  handleInstIndex!: number;
  timeIndex!: number;
  columnJson: any = [];
  checked: boolean = false;
  fdidChecked: boolean = false;
  givenNameForFDID: string = '';
  timeInForceValue: any;
  clearValueJSON: Array<any> = [];
  isLoadingResults: boolean = false;
  timeInForceChoice!: string;
  fieldDictionaryList!: FieldDictionary[];

  constructor(private emitterService: EmitterService,
    private UrlsService: UrlsService,
    private messageService: MessageService,
    public UserService: UserService, 
    private gridService: GridService, 
    public dataService:DataService,
    private SharedHttpClientService: SharedHttpClientService,
    private confirmationService: ConfirmationService,
    private finraExceptionService: FinraExceptionService,
    public eventConversionService: EventConversionService,
    public constantService: ConstantService,
    public userService:UserService,
    private datePipe: DatePipe) {
    this.aggoOrdersCols = AggoOrderColumnsJSON;
    this.aggoOrdersData = [];
    this.tradeSideDetailsCols = TDETColumnsJSON;
    this.handlingInstructionCols = this.userService.handlingInstructionsJSON;
    this.legDetailsCols = LegDetailsColumnsJSON;
    this.tradeSideDetailsData = [];    
  }
  
  ngOnInit() {
    this.isClickedOnce = false;
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (this.rowData)
    }
    this.getAggoOrdersColumns();
    this.getTDETColumns();
    this.getLegDetailsColumns();

    if (this.value == 'View') {
      this.getCATEditOriginalJSON(this.value, this.index, this.rowData);

    } else if (this.value == 'edit') {
      this.getCATEditOriginalJSON(this.value, this.index, this.rowData);
    }
  }

  getAggoOrdersColumns() {
    let column: any = this.aggoOrdersCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.aggoOrdersCols = this.gridService.getGridColumns(column);
    }
  }

  getTDETColumns() {
    let column: any = this.tradeSideDetailsCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.tradeSideDetailsCols = this.gridService.getGridColumns(column);
    }
  }

  getLegDetailsColumns() {
    let column: any = this.legDetailsCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.legDetailsCols = this.gridService.getGridColumns(column);
    }
  }

  getCATEditOriginalJSON(value:any, index:any, rowData: any) {
    if (this.screenType === 'rowViewer' || this.screenType === 'comparativeReviewException') {
      this.selectedRowOriginalJSON = rowData;
      this.selectedRowJSONDataset[0] = rowData;
      let data = {
        "mpid":this.UserService.getActiveMPID(),
        "eventType":rowData['type'].toLowerCase(),
        "firmROEID":rowData['firmROEID'],
        "reportDate":rowData['reportDate'],
    } 
      this.getOrignalJSON(rowData,value, index,APIURL.CAT_ROE_Get_OriginalJSON, data,true);
    } else if (this.screenType === 'catException') {
      this.selectedRowOriginalJSON = JSON.parse(rowData.originalJSON.replace(/'/g, '"'));
      this.selectedRowJSONDataset[0] = this.selectedRowOriginalJSON;
      let data = {
        "mpid": this.UserService.getActiveMPID(),
        'reportDate': rowData['reportDate'],
        'firmROEID': rowData['firmROEID'],
        'pageName': "CAT-Exception",
        'eventType': rowData['type'],
        "fileID": this.selectedRow[0].fileID != null ? this.selectedRow[0].fileID : 0,
      };
      this.getOrignalJSON(rowData,value, index,APIURL.CAT_Exception_Get_OriginalJSON, data, false);
    } else if(this.screenType === 'finraException') {
      let data = {
        "mpid":this.UserService.getActiveMPID(),
        "eventType":rowData['type'].toLowerCase(),
        "firmROEID":rowData['firmROEID'],
        "reportDate":rowData['reportDate'],
    }
      this.getOrignalJSONForFinraException(rowData,value, index,APIURL.CAT_ROE_Get_OriginalJSON, data)
    }
    if(this.rowData?.timeInForce == null){
      this.selectedRowJSONDataset[0]["timeInForce"]={"DAY": ""}     
    } 
  }
  getOrignalJSONForFinraException(rowData:any,value:any, index:any, url:any, data:any) {
    this.isLoadingResults=true;
    this.SharedHttpClientService.post(this.UrlsService.setAPIURl(url), data)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (dataset:any) => {
          let data: any = dataset;
        this.isLoadingResults=false;
        if (data.Data.length > 0) {
          this.selectedRowJSONDataset[0] = (data.Data[0].json);
          this.prepareJsonData(value, index, rowData);
        } else {
          let data = {
            "mpid": this.UserService.getActiveMPID(),
            'reportDate': rowData['reportDate'],
            'firmROEID': rowData['firmROEID'],
            'pageName': "CAT-Exception",
            'eventType': rowData['type'],
            "fileID": this.selectedRow[0].fileID != null ? this.selectedRow[0].fileID : 0,
          };
          this.SharedHttpClientService.post(this.UrlsService.setAPIURl(APIURL.CAT_Exception_Get_OriginalJSON), data)
          .pipe(map((response: Response) => {
            return response;
          }))
          .subscribe({
            next: (dataset:any) => {
              let data: any = dataset;
                this.isLoadingResults=false;
                if (data.Data && data.Data.length > 0) {
                  this.selectedRowJSONDataset[0] = JSON.parse((data.Data[0].json).replace(/'/g, '"'));
                  this.prepareJsonData(value, index, rowData);
                } else {
                  this.finraExceptionService.showROEEdit = false;
                  this.messageService.add({ severity: 'error', summary: 'error', detail: 'Record Not Found' });
                }
            },    
            error: (err: HttpErrorResponse) => {
              this.isLoadingResults=false;
              this.finraExceptionService.showROEEdit = false;
              this.messageService.add({ severity: 'error', summary: 'error', detail: 'Record Not Found' });
            }
          });
        }
        },
        error: (err: HttpErrorResponse) => {
          this.finraExceptionService.showROEEdit = false;
          this.messageService.add({ severity: 'error', summary: 'error', detail: 'Record Not Found' });
        }
      });  
  }
  getOrignalJSON(rowData:any,value:any, index:any, url:any, data:any, isROEViewer:boolean) {
    this.isLoadingResults=true;
    this.SharedHttpClientService.post(this.UrlsService.setAPIURl(url), data)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (dataset:any) => {
          let data: any = dataset;
        this.isLoadingResults=false;
        if (data.Data.length > 0) {
          if(isROEViewer) {
            this.selectedRowJSONDataset[0] = (data.Data[0].json);
          } else {
            this.selectedRowJSONDataset[0] = JSON.parse((data.Data[0].json).replace(/'/g, '"'));

          }
        }
        this.prepareJsonData(value, index, rowData);
        },

        error: (err: HttpErrorResponse) => {
          this.isLoadingResults=false;
          this.prepareJsonData(value, index, rowData);
        }
      });  
  }
  prepareJsonData(value: any, index: any, rowData:any) {
    if (!this.isMultiEdit) {
      this.selectedRow = [];
      this.selectedRow[0] = (rowData)
    }
    this.quickviewcols = [];
    this.aggoOrdersData = [
      {
        'orderID': rowData.orderID,
        'orderKeyDate': rowData.orderKeyDate,
        'quantity': rowData.quantity,
        'originatingIMID': rowData.originatingIMID
      }
    ];
    this.tradeSideDetailsData = [
      {
        'orderKeyDate': rowData.orderKeyDate,
        'orderID': rowData.orderID,
        'side': rowData.side,
        'quantity': rowData.quantity,
        'firmDesignatedID': rowData.firmDesignatedID,
        'accountHolderType': rowData.accountHolderType,
        'originatingIMID': rowData.originatingIMID
      }
    ];
    let tempRow: any = this.selectedRow[0];
    this.EventType = '';
    this.EventType = tempRow.type;
    this.prepareQuickviewPanel();
    
      if (value === 'edit') {
        this.Edit = true;
      } else if (value === 'View') {
        this.View = true
      }

      let flag = tempRow.rsmsStatus;
      let ExceptionCode = tempRow.failureCode;
      if (this.EventType != "--" && this.EventType != "" && this.EventType != " " && this.EventType != null) {
        this.Editviewcols = [];

        this.tempDataset = this.cloneData(this.selectedRowJSONDataset[0]);/* *** set old data for backup */
        if (value == 'OrderID') {
          this.emitterService.isOrderViewerOpenCloseEvent.emit(
            {
              display: true,
              rowData: rowData,
              pageName: 'CAT-Exception'
            });
        }
        this.displayDialog = true;
      } else {
        if (value == 'View') {
          this.View = true;
        } else {
          let msginfo = 'Flag=' + flag;
          if (this.EventType == "--" || this.EventType == "" || this.EventType == " " || this.EventType == null)
            msginfo = 'Event Type=' + this.EventType;
          if (flag == 'D')
            msginfo = 'Flag=' + flag;
          this.messageService.add({ severity: 'warn', summary: 'Info Message', detail: 'Selected record is non editable please check ' + msginfo });
          this.displayDialog = false;
        }
      }
    
  }
  
  prepareQuickviewPanel() {
    this.quickviewcols = [];
    this.quickviewcols=this.gridService.prepareQuickviewPanel(this.EventType.toLocaleUpperCase());
  }

  cloneData(tempRow: any, action?: string) {
    this.timeInForceObj = tempRow ? tempRow.timeInForce : null;
    this.handlingInstructionObj = tempRow && tempRow.handlingInstructions !== null && tempRow.handlingInstructions !== "" && tempRow.handlingInstructions !== undefined ? JSON.stringify(tempRow.handlingInstructions) : null;
    this.Editviewcols = [];
    let len = Object.keys(this.quickviewcols).length;
    let FailureDescription = "";
    for (let i = 0; i < Object.keys(this.quickviewcols).length; i++) {
      let tempKeyName = this.quickviewcols[i]?.mappingkey;
      let isError = false;
      if (Util.isDefinedAndNotNull(tempKeyName)) {
        let error_code_object: any;
        error_code_object = this.UserService.getFieldDictionaryObject(tempKeyName);
        if (error_code_object) {
          let keyofValue = error_code_object["field_Name"];
          this.quickviewcols[i].datatype = error_code_object['data_Type'];
          this.Editviewcols[i] =
            {
              "ui_Field_Name": error_code_object["ui_Field_Name"],
              "field_Name": error_code_object["field_Name"],
              "default_Value": error_code_object["default_Value"],
              "value": this.getValueofField(keyofValue),
              "datatype": this.quickviewcols[i].datatype,
              "time": "00:00:00",
              "display": this.quickviewcols[i].display,
              "db_columnname": this.quickviewcols[i].db_columnname,
              "dropdowntype": error_code_object["dropdowntype"],
              "dropdownvalue": this.getFilteredValueOfField(error_code_object), // Search & Assign Dynamic DB stored Dropdown Values for Every Field
              "description": error_code_object["description"],
              "error_Code": error_code_object["error_Code"],
              "error_Code_Description": error_code_object["error_Code_Description"],
              "isException": isError,
              "isDisable": this.quickviewcols[i].disabled
            }
          let datatype: string = error_code_object["data_Type"];
          if (datatype == 'Choice') {
            this.Editviewcols[i].datatype = "Choice";
          }
        }
        else {
          this.Editviewcols[i] =
            {
              "ui_Field_Name": this.quickviewcols[i].ui_columnname,
              "field_Name": this.quickviewcols[i].mappingkey,
              "default_Value": "",
              "value": this.getValueofField(this.quickviewcols[i].mappingkey),
              "datatype": this.quickviewcols[i].datatype,
              "time": "00:00:00",
              "display": this.quickviewcols[i].display,
              "db_columnname": this.quickviewcols[i].db_columnname,
              "dropdowntype": this.quickviewcols[i].dropdown,
              "dropdownvalue": this.quickviewcols[i].dropdownvalue,
              "description": "",
              "error_Code": "",
              "error_Code_Description": "",
              "isException": isError,
              "isDisable": this.quickviewcols[i].disabled
            }
        }
      }
      if (this.isMultiEdit) {
        if (this.Editviewcols[i].ui_Field_Name === 'sellDetails' || this.Editviewcols[i].ui_Field_Name === 'buyDetails' 
        || this.Editviewcols[i].ui_Field_Name === 'clientDetails' || this.Editviewcols[i].ui_Field_Name === 'firmDetails'
        ||  this.Editviewcols[i].ui_Field_Name === 'legDetails' || this.Editviewcols[i].ui_Field_Name === 'aggregatedOrders') {
          this.Editviewcols[i]['value'] = [{}];
        } else if (this.Editviewcols[i].ui_Field_Name === 'timeInForce') {
          if (this.selectedRowJSONDataset[0][this.Editviewcols[i].ui_Field_Name] !== undefined &&
             this.selectedRowJSONDataset[0][this.Editviewcols[i].ui_Field_Name] !== null) {
            this.newLabel = this.getObjectKey(this.selectedRowJSONDataset[0][this.Editviewcols[i].ui_Field_Name]);
            this.timeInForceValue = undefined;
          }
        } else if (this.Editviewcols[i].ui_Field_Name === 'handlingInstructions') {
          this.handlingInstructionData = [{}];
          this.handlingInstructionCols = [];
        } else if (this.Editviewcols[i].ui_Field_Name === 'type' || this.Editviewcols[i].ui_Field_Name === 'CATReporterIMID' ||
        this.Editviewcols[i].ui_Field_Name === 'reportDate' || this.Editviewcols[i].ui_Field_Name === 'groupName') {
          this.Editviewcols[i]['value'] =  this.Editviewcols[i]['value'] 
        } else {
          this.Editviewcols[i]['value'] = null;
        }
      }else{
        if (this.Edit && (this.Editviewcols[i].ui_Field_Name === 'sellDetails' || this.Editviewcols[i].ui_Field_Name === 'buyDetails' 
        || this.Editviewcols[i].ui_Field_Name === 'clientDetails' || this.Editviewcols[i].ui_Field_Name === 'firmDetails'
        ||  this.Editviewcols[i].ui_Field_Name === 'legDetails' || this.Editviewcols[i].ui_Field_Name === 'aggregatedOrders')) {
          this.Editviewcols[i]['value'] =this.Editviewcols[i]['value'] != null && this.Editviewcols[i]['value'] != undefined ? this.Editviewcols[i]['value']:[{}];
        }
      }

    }
    return this.Editviewcols;
  }

  getValueofField(fieldName: string) {
    if (this.View) {
      if (fieldName === 'buyDetails' || fieldName === 'sellDetails' 
      || fieldName === 'clientDetails' || fieldName === 'firmDetails' 
      || fieldName === 'legDetails' || fieldName === 'timeInForce' 
      || fieldName === 'handlingInstructions' || fieldName === 'aggregatedOrders')  {
        return JSON.stringify(this.selectedRowJSONDataset[0][fieldName]);
      }
      }
     if (fieldName === 'handlingInstructions') {
      let obj = this.selectedRowJSONDataset[0][fieldName]
      let result = obj!== undefined? Object.keys(obj).map(function (key) {
        return [(key), obj[key]];
      }): [];
      this.selectedRowJSONDataset[0][fieldName] = this.selectedRowJSONDataset[0][fieldName] !==undefined ? [this.selectedRowJSONDataset[0][fieldName]] : [{}];
      this.handlingInstructionCols = this.gridService.getGridColumnsHasValues(result);
      this.handlingInstructionData =   this.selectedRowJSONDataset[0][fieldName];
    } else if (fieldName === 'reportDate' || fieldName === 'rsmsStatus' || fieldName === 'groupName'
     || fieldName === 'errorCodeList' || fieldName === 'createDate' || fieldName === 'updateDate' || fieldName === 'lastUpdatedBy') {
        return this.selectedRow[0][fieldName];
      
    } else if (fieldName === 'timeInForce') {
      if(this.selectedRowJSONDataset[0][fieldName] !== undefined && this.selectedRowJSONDataset[0][fieldName] !== null) {
        this.newLabel = this.getObjectKey(this.selectedRowJSONDataset[0][fieldName]);
        this.timeInForceValue =  this.selectedRowJSONDataset[0][fieldName][this.getObjectKey(this.selectedRowJSONDataset[0][fieldName])];
      }
    } else {
      return this.selectedRowJSONDataset[0][fieldName];
    }
  }

  /* Get Filtered Dropdown Values for respective Fields (e.g. - side - ME* Event Types - B/SL/SS/SX & MO* Event Types - B/S) */
  getFilteredValueOfField(fieldObject: any) {
    let fieldOptions = fieldObject.dropdownvalue;
      if(fieldObject.field_Name === "side") {
        if(this.EventType.toLocaleLowerCase().startsWith("me")) {
          fieldOptions = fieldObject.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMEEventTypes.includes(rowObj.value));
        } else if (this.EventType.toLocaleLowerCase().startsWith("mo")) {
          fieldOptions = fieldObject.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMOEventTypes.includes(rowObj.value));
        }
      }
    return fieldOptions;
  }

  save() {
    this.givenNameForFDID = '';
    this.checked = false;
    this.isClickedOnce = true;
    let  handlingArr :any= [];
    let handlingObj: any;

    /* Form necessary Field Validation */
      if(!this.validateEssentialFormFields()) {
        return false;
      }
    /* End of Form necessary Field Validation */

    this.Editviewcols.filter((element:any, index:any) => {
      if(element.field_Name === 'handlingInstructions' && this.handlingInstructionData) {
        this.Editviewcols[index].value = {};
        this.handlingInstructionCols.forEach((element:any) => {
         let  keys = Object.keys(this.handlingInstructionData[0]);
         if(this.handlingInstructionData[0] !== '{}' && keys.indexOf(element.header) >= 0)
         { 
          handlingArr.push(this.userService.getHandlingInstructionValue(element,this.Editviewcols[index], this.handlingInstructionData[0]));
         }
        });
        if(handlingArr.length>0){
        handlingObj = Object.assign.apply(Object, handlingArr); // Array of obj into one obj
        }
        this.Editviewcols[index].value = this.handlingInstructionCols.length > 0 && handlingObj !== undefined ? this.removeNullValueObj(handlingObj) : null;
        this.Editviewcols[index].value = this.Editviewcols[index].value !== null && Object.keys(this.Editviewcols[index].value).length === 0 ? null : this.Editviewcols[index].value;
      } else if (element.field_Name === 'timeInForce') {
        this.Editviewcols[index].value = this.timeInForceValue ? { [this.newLabel]: this.timeInForceValue } : undefined;
      } else if (element.field_Name === 'buyDetails' || element.field_Name === 'sellDetails' ||
      element.field_Name === 'clientDetails' || element.field_Name === 'firmDetails' ||
      element.field_Name === 'legDetails') {
      this.Editviewcols[index].value = Object.keys(this.removeNullValueObj(this.Editviewcols[index].value == undefined || this.Editviewcols[index].value[0])).length === 0 ? null : this.Editviewcols[index].value;
    } else if (element.field_Name === 'aggregatedOrders') { 
      this.Editviewcols[index].value = this.Editviewcols[index].value !== null && this.Editviewcols[index].value !== undefined && Object.keys(this.Editviewcols[index].value[0]).length === 0 ? null : this.Editviewcols[index].value;
    } else if(element.field_Name == 'firmDesignatedID' && this.Editviewcols[index].value !== null && this.Editviewcols[index].value !== undefined){
      this.Editviewcols[index].value =  this.Editviewcols[index].value.trim().length == 0 ? null : this.Editviewcols[index].value.trim(); 
    }
    });

    if(this.isMultiEdit) {
      this.multiEditSave();
    } else {
      this.CallUpadteAPI();
    }

    this.selectedRow = [];
    this.displayDialog = false;
    this.newLabel = '';
    this.handlingInstructionObj = {};
    this.timeInForceObj = {};
    this.dataService.roeSelectedRecords=[];
    return true;
  }

  validateEssentialFormFields() {
    let updatedJSONObject: any = {};

    this.Editviewcols.forEach((element:any, index:any) => {
      if (element.value !== null && element.value !== "" && element.value !== undefined) {
        updatedJSONObject[element.field_Name] = this.Editviewcols[index].value;
      }
    });

    /* Validation for Total Multileg Details */
      if(updatedJSONObject.hasOwnProperty('numberOfLegs') && (updatedJSONObject.numberOfLegs!==null && updatedJSONObject.numberOfLegs!==undefined && updatedJSONObject.numberOfLegs!=='' && updatedJSONObject.numberOfLegs!==0) && updatedJSONObject.hasOwnProperty('legDetails') && (updatedJSONObject.numberOfLegs !== updatedJSONObject.legDetails.length)) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter matching info for Leg Details and NumberOfLegs' });
        this.isClickedOnce = false;
        return false;
      } else if(updatedJSONObject.hasOwnProperty('numberOfLegs') && updatedJSONObject.numberOfLegs > 0 && updatedJSONObject.hasOwnProperty('legDetails') && !this.dataService.hasAnyEmptyObjectInObjectArray(updatedJSONObject.legDetails)) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter data in All Leg Details' });
        this.isClickedOnce = false;
        return false;
      }
    /* End of Validation for Total Multileg Details */

    /* Validation for AggoOrder Details */
      if(updatedJSONObject.hasOwnProperty('aggregatedOrders') && updatedJSONObject.aggregatedOrders.length > 0 && Object.keys(this.dataService.removeNullValueObj(updatedJSONObject.aggregatedOrders[0])).length > 0 && (updatedJSONObject.hasOwnProperty('representativeInd') || !updatedJSONObject.hasOwnProperty('representativeInd')) && (updatedJSONObject.representativeInd===null || updatedJSONObject.representativeInd===undefined || updatedJSONObject.representativeInd==='')) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter RepresentativeInd relevant with Aggo Details' });
        this.isClickedOnce = false;
        return false;
      } else if(updatedJSONObject.hasOwnProperty('aggregatedOrders') && updatedJSONObject.aggregatedOrders.length > 1 && !this.dataService.hasAnyEmptyObjectInObjectArray(updatedJSONObject.aggregatedOrders)) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter data in All Aggo Details' });
        this.isClickedOnce = false;
        return false;
      }
    /* End of Validation for AggoOrder Details */

    return true;
  }

  multiEditSave() {
    let multiEditPayload = {
      user:this.UserService.getUserName(),
      mpid: this.UserService.getActiveMPID(),
      updatedJSON: this.removeNoValueFieldsFromEditviewcols(),
      firmROEIDList: this.firmROEIDList,
      eventType: this.rowData.type
    }
    let msg = '';
      msg = 'Do you want to save changes for '+ this.correctCodeLength +' records?';
    this.confirmationService.confirm({
      message: msg,
      key: 'confirmationDialogForEdit',
      accept: () => {
        this.isLoadingResults=true;
        this.SharedHttpClientService.post(this.UrlsService.setAPIURl(APIURL.CAT_ROE_Viewer_MultiEdit), multiEditPayload)
      .pipe(map((response: Response) => {
        return response.text();
      }))      
      .subscribe({
        next: (Element:any) => {
          this.isLoadingResults=false;
          this.tempDataset = [];
          this.Edit = false;
          this.isClickedOnce = false;
          this.handlingInstructionData = [];
          this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Record Updated Successfully' });
          this.closeDialog.emit(true);
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: 'Update', detail: 'Record Update Failed!' });
          this.isClickedOnce = false;
          this.isLoadingResults=false;
          this.closeDialog.emit(false);
        }
      });
      },
      reject: () => {
        this.isClickedOnce = false;
      }
    });
  }
  clearValue(row:any) {
    row.isMultiEdited = true;
    this.clearValueJSON.push(row)
     this.clearValueJSON =  this.clearValueJSON.filter((n, i) =>  this.clearValueJSON.indexOf(n) === i);
  }
  removeNoValueFieldsFromEditviewcols() {
    let object: any = {};
    this.Editviewcols.forEach((element:any, index:any) => {
      if (element.value !== null && element.value !== "" && element.value !== undefined) {
        object[element.field_Name] = this.Editviewcols[index].value;
      }
    });
    if(this.clearValueJSON.length >= 1) {
      this.clearValueJSON.forEach((element)=> {
        object[element.field_Name] = "";
      });
      /* Remove Blank TimeInForce Value from Updated JSON Object */
      if(object.timeInForce === undefined || object.timeInForce === "" || object.timeInForce === null) {
        delete object.timeInForce;
      }
    }
    return object;
  }
  setEditRowValue(index: number, key: string) {
    /* Receiving updated TimeInForce Value */
      let timeInForceValue = this.userService.getTimeInforceValue(key, this.Editviewcols[index].field_Name, false, this.Editviewcols);
      this.timeInForceValue = timeInForceValue;
    /* End of Receiving updated TimeInForce Value */

    this.Editviewcols[index].value = {
      [key]: timeInForceValue,
    }
  }
  getObjectKey(obj:any) {
    const key = Object.keys((obj))[0];
    return key;
  }

  removeNullValueObj(obj:any) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === "" || obj[key] === null) {
        delete obj[key]
      }
    })
    return obj
  }
  CallUpadteAPI() {
    /* *** Update API Call */
    let object: any = {};
    let tempRow = this.selectedRowJSONDataset[0]
    this.Editviewcols.forEach((element:any, index:any) => {
      if (element.value !== null && element.value !== "" && element.value !== undefined) {
        object[element.field_Name] = this.Editviewcols[index].value;
        tempRow[element.field_Name] = this.Editviewcols[index].value;
      } 
      else if(element.field_Name === 'buyDetails' || element.field_Name === 'sellDetails' 
      || element.field_Name === 'clientDetails' || element.field_Name === 'firmDetails' 
      || element.field_Name === 'legDetails' || element.field_Name === 'aggregatedOrders') {
        tempRow[element.field_Name] = [];
      } 
      else {
        tempRow[element.field_Name] = null;
      }
    });

    let data = {
      "Data": [
      {
      "fileID": this.selectedRow[0].fileID != null ? this.selectedRow[0].fileID : 0,
      "type": tempRow['type'] != null ? tempRow['type'].toString() : '',
      "reportDate": this.selectedRow[0].reportDate,
      "reporterID": this.selectedRow[0].CATReporterIMID,
      "firmROEID": tempRow['firmROEID'] != null ? tempRow['firmROEID'].toString() : '',
      "groupName": this.selectedRow[0].groupName.toString(),
      "json":  tempRow,
      "user":this.UserService.getUserName()
      }
      ]
      }
    this.isLoadingResults=true;
    this.SharedHttpClientService.postPlainText(this.UrlsService.setAPIURl(APIURL.CAT_ROE_Viewer_Save), data)
    .pipe(map((response: Response) => {
      return response;
    }))
    .subscribe({
      next: (Element:any) => {
        this.isLoadingResults=false;
          let data: any = Element;
          if (data == "Update Failed")
            this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Record Update Failed!' });
          if (data == "Record updated successfully") {
            tempRow = this.selectedRowOriginalJSON;
            tempRow['rsmsStatus'] = 'U';
            this.selectedRow[0] = tempRow;
            this.tempDataset = [];
            this.Edit = false;
            this.isClickedOnce = false;
            this.handlingInstructionData = [];
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Record Updated Successfull' });
            this.closeDialog.emit(true);
            this.Edit = false; 
            
          }else{
            this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Record Update Failed, Don\'t remove required field' });
          }      
      },
      error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Record Update Failed' });
            this.isClickedOnce = false;
            this.isLoadingResults=false;
            this.closeDialog.emit(false);
      }
    });

  }

  getFDID(index: number) {
    this.isLoadingResults=true;
    this.SharedHttpClientService.post(
      this.UrlsService.setAPIURl(
        APIURL.CAT_Exception_Get_FDID
        ), {
          "mpid": this.UserService.getActiveMPID(),
          "givenName": this.givenNameForFDID
      })
      .subscribe({
        next: (data:any) => {
          this.isLoadingResults=false;
            this.Editviewcols[index].value = data.Data.length > 0? data.Data[0].generatedFDID: null;
            if(this.Editviewcols[index].value === null) {
              this.messageService.add({ severity: 'error', summary: 'Not Found', detail: 'Firm Designated ID not found for given name' });
            } else {
              this.messageService.add({ severity: 'success', summary: 'record Found', detail: 'Updated Firm Designated ID' });
            }
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'Firm Designated ID not found for given name' });
          this.isLoadingResults=false;
        }
      });
  }
  ngOnDestroy() {

  }
  getChildColumns(fieldName:any){
    if(["legDetails"].includes(fieldName)) {
      /* Provide Drop Down Field Values to respective Fields (Side/OpenCloseIndicator) */
        if(this.legDetailsCols.length > 0) {
          for(let i=0; i < this.legDetailsCols.length; i++) {
            let Field_Dictionary_Object;
            if(this.legDetailsCols[i]["dropdown"].toLowerCase()==="yes") {
              Field_Dictionary_Object = this.userService.getFieldDictionaryObject(this.legDetailsCols[i]["field"]);
              this.legDetailsCols[i]["dropdownvalue"] = Field_Dictionary_Object.dropdownvalue;
            }
          }
        }

      return this.legDetailsCols;
    } else if (["clientDetails", "firmDetails", "buyDetails", "sellDetails"].includes(fieldName)) {
      /* Provide Drop Down Field Values to respective Fields (Side) */
      if(this.tradeSideDetailsCols.length > 0) {
        for(let i=0; i < this.tradeSideDetailsCols.length; i++) {
          let Field_Dictionary_Object;
          if(this.tradeSideDetailsCols[i]["dropdown"].toLowerCase()==="yes") {
            Field_Dictionary_Object = this.userService.getFieldDictionaryObject(this.tradeSideDetailsCols[i]["field"]);
            this.tradeSideDetailsCols[i]["dropdownvalue"] = Field_Dictionary_Object.dropdownvalue;
            if(this.tradeSideDetailsCols[i]["field"].toLowerCase()==="side") {
              if(this.selectedRow[0]["type"].toLocaleLowerCase().startsWith("me")) {
                this.tradeSideDetailsCols[i]["dropdownvalue"] = this.tradeSideDetailsCols[i]["dropdownvalue"].filter((rowObj: any) => this.constantService.validSidesMEEventTypes.includes(rowObj.value));
              } else if (this.selectedRow[0]["type"].toLocaleLowerCase().startsWith("mo")) {
                this.tradeSideDetailsCols[i]["dropdownvalue"] = this.tradeSideDetailsCols[i]["dropdownvalue"].filter((rowObj: any) => this.constantService.validSidesMOEventTypes.includes(rowObj.value));
              }
            }
          }
        }
      }
    }

    return this.tradeSideDetailsCols;
  }

  /* Get Dropdown Values for LegDetails/BuyDetails/SellDetails/FirmDetails/ClientDetails etc. Dropdown Fields */
  getCATDetailsFieldDropdownValues(editRow: any, col: any, tradeSideRowData: any) {
    let fieldOptions = col.dropdownvalue;
      if(["legDetails"].includes(editRow.field_Name)) {
        if(["side"].includes(col.field)) {
          if(tradeSideRowData.symbol && tradeSideRowData.symbol !== null && tradeSideRowData.symbol.length > 0 && (!tradeSideRowData.optionID || tradeSideRowData.optionID === null)) {
            fieldOptions = col.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMEEventTypes.includes(rowObj.value));
          } else if(tradeSideRowData.optionID && tradeSideRowData.optionID !== null && tradeSideRowData.optionID.length > 0 && (!tradeSideRowData.symbol || tradeSideRowData.symbol === null)) {
            fieldOptions = col.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMOEventTypes.includes(rowObj.value));
          }
        }
      }
    return fieldOptions;
  }

getDateTimeTFormate(keyName:any, datetime:any, index:any){
  try {
    this.Editviewcols[index].value = this.userService.getDateTimeTFormate(datetime, keyName);
    if (this.userService.timeStampErrorField == keyName) {
      this.messageService.add({ severity: 'error', summary: 'Invalid DateTime', detail: 'Enter the date and time in as - '+this.userService.getDateTimeTFormatePattern(keyName)+' '+this.Editviewcols[index].value });
    }else{
        if (this.userService.timeStampErrorField === keyName || !this.userService.timeStampErrorField) {
          this.userService.timeStampErrorField = ''; 
        }
    }
  } catch (e) {
    this.userService.timeStampErrorField = keyName;
    this.messageService.add({ severity: 'error', summary: 'Invalid DateTime', detail: 'Enter the date and time in as - '+this.userService.getDateTimeTFormatePattern(keyName)+' '+this.Editviewcols[index].value });
  }
}

}
